import { FileKeyPair } from '../file-key';

export enum AnnuityReceiptStatus {
  Accepted = 'ACCEPTED',
  SubmittedForReview = 'SUBMITTED_FOR_REVIEW',
  Archived = 'ARCHIVED',
  Rework = 'REWORK',
  ReworkDisagreement = 'REWORK_DISAGREEMENT',
  Replace = 'REPLACE',
}

export interface FulfillmentReceiptRequest {
  annuityFulfillmentReceiptFile?: FileKeyPair;
  newAnnuityFulfillmentReceiptFile?: FileKeyPair;
  annuityReceiptStatus?: AnnuityReceiptStatus;
  visibleToClient?: boolean;
}

export interface FulfillAnnuityRequest {
  annuityId: number;
  annuityFulfillmentReceipts: FulfillmentReceiptRequest[];
  fulfillmentDate: string;
  vendorReferenceNumber: string;
  fulfillmentComplete?: boolean;
  reworkResponse?: string;
  updateExpectedDate?: string;
}
